import { AccountApi } from "bonusx-api-main-manager";
import { defaultApiConfig } from "../common/env";
import axiosInstance from "./axios-config-singleton/axios-config-singleton.instance";

export const accountApi = new AccountApi(defaultApiConfig, undefined, axiosInstance);
